import { countDecimals } from '../../../core/formatter/formatNumber';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../validData';
import { Kennzahl, parseKey } from '../strukturiert/Kennzahl';
import { setKennzahl } from '../strukturiert/KennzahlTools';

export function extractKlimagase(data: any, base: any, standort: any) {
    const standorte = data[IDs.ENT_STANDORT];
    const klimagase = data[IDs.ENT_KLIMAGASE].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);
    // console.log('KG', klimagase);
    const co2_klimagase = data[IDs.ENT_CO2_FAKTOREN_KLIMAGASE];

    // Standorte-Map
    const veranstaltungen_enabled = Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0 ? data[IDs.ENT_KONFIGURATION][0].veranstaltungen_orig === 1 : false;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);

    /******************** KLIMAGASE ****************************************************************** */
    klimagase.forEach((item: any) => {
        const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
        if (!standortTid || !standorteMap[standortTid] || !isValid(item, IDs.ENT_KLIMAGASE, data)) {
            return;
        }
        const jahr = item.jahr;
        if (!base[jahr]) {
            base[jahr] = {};
        }
        // const gas = co2_klimagase.find((g: any) => g.tid === item.art_tid_orig);
        const gas = findCO2FaktorKlimagase(co2_klimagase, item);
        // console.log('KG-Item: ', gas, item);
        if (!gas) {
            return; // Sollte nicht passieren
        }
        const gas_key = `co2_fussabdruck_${gas.info}_menge`;
        base[jahr][gas_key] = (base[jahr][gas_key] || 0) + item.menge;
        setKennzahlen(data, standort, item);

        const key_datenqualitaet = `${gas.info}_datenqualitaet`;
        if (!base[jahr][key_datenqualitaet]) {
            base[jahr][key_datenqualitaet] = [];
        }
        base[jahr][key_datenqualitaet].push({
            wert: +(item.menge || 0),
            datenherkunft: +(item.datenherkunft || 0),
            bewertung: 1
        });
    });
}

function findCO2FaktorKlimagase(faktoren: Array<any>, item: any): any {
    // Siehe getCO2Aequivalent
    // wir sind entweder
    // .. genau das Jahr
    // .. kleiner und näher am gesuchten Jahr
    // .. größer, wenn noch kein kleineres Jahr gefunden wurde und dafür näher dran
    const fktFlt = faktoren.filter((f: any) => f.art_orig === item.art_tid_orig && f.jahr <= item.jahr)
        .sort((a: any, b: any) => a.jahr - b.jahr);
    if (fktFlt.length > 0) {
        return fktFlt[fktFlt.length - 1];
    } else {
        const fktFlt2 = faktoren.filter((f: any) => f.art_orig === item.art_tid_orig && f.jahr > item.jahr)
            .sort((a: any, b: any) => a.jahr - b.jahr);
        if (fktFlt2.length > 0) {
            // console.log('Faktor aus nächstem Jahr', item.jahr, fktFlt2[0].jahr, fktFlt2[0]);
            return fktFlt2[0];
        }
    }
    return undefined;
}

function setKennzahlen(data: any, standort: any, item: any) {
    if (!standort) {
        return;
    }
    data = data || {};
    item = item || {};
    // const faktor: any = (data[IDs.ENT_CO2_FAKTOREN_KLIMAGASE] || []).find((faktor: any) => faktor.art_orig === item.art_tid_orig) || {};
    const faktor: any = findCO2FaktorKlimagase(data[IDs.ENT_CO2_FAKTOREN_KLIMAGASE] || [], item) || {};
    let faktorWert: number = typeof faktor !== 'undefined' && faktor !== null ? faktor.wert : null;
    const faktorQuelle: string = faktor.quelle || null;
    const key: string = (faktor.info || '').toString().toLowerCase();
    const name: string = faktor.name;
    const prefix: string = 'klimagase'
    const unit: string = 'kg';
    const unitCo2: string = 'tCO₂Äq/kg';
    // const value: number = item.menge;
    let num: number = 1;

    if (faktorWert !== null) {
        num = 10 ** countDecimals(faktorWert);
        faktorWert = Math.round(faktorWert * num) / (num * 1000);
        //     num = 10 ** countDecimals(faktorWert);
    }
    // const valueCo2: number = Math.round((value * (faktorWert || 1)) * num) / num;
    setKennzahl(
        standort.tid, data, `${parseKey('verbrauch')} Klimagase "${name}"`, Kennzahl.BEREICH_KLIMAGASE, key, 'menge', item, unit, null,
        `${prefix}_gesamt`, `${parseKey('verbrauch')} Klimagase Gesamt`
    );
    if (faktorWert) {
        setKennzahl(
            standort.tid, data, `CO₂-Emission ${name}`, Kennzahl.BEREICH_KLIMAGASE, `${key}_co2`, 'menge', item, 'tCO₂Äq', unit, `${prefix}_gesamt_co2`,
            'CO₂-Emission Klimagase Gesamt', null, null, faktorWert, faktorQuelle, unitCo2
        );
    }
}
